var _defs, _rect, _polyline, _path, _polyline2, _polyline3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMpLogoWhite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1085.68 1085.68",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-1,.cls-2{fill:none;stroke-miterlimit:10;}.cls-1{stroke:#070707;stroke-width:6px;}.cls-2{stroke:#000;stroke-width:13px;}\n        "))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "mp_logo_white") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "rect_black",
    className: "cls-1",
    x: 3,
    y: 3,
    width: 1079.68,
    height: 1079.68
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    id: "path_black",
    className: "cls-2",
    points: "335.78 881.23 184.09 881.23 184.09 681.32"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M879.52,697.92q-19.24-17.83-50-17.84H750.21l-72.1,86.56L606,680.08H567.83V899.54h42.42V745.44h1.25L675,822.73h6l63.46-77.29h1.26V862.9l-1,36.64h43.42v-92h39.84q31.88,0,51.36-17.6t19.48-46Q898.76,715.75,879.52,697.92Zm-34.09,68.64q-9.51,7.79-26.47,7.78H788.08V713.23H816q39,0,39,30.32Q854.94,758.79,845.43,766.56Z",
    transform: "translate(2.83 2.68)"
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    id: "polyline_black_1",
    className: "cls-2",
    points: "731.74 183.46 883.43 183.46 883.43 383.37"
  })), _polyline3 || (_polyline3 = /*#__PURE__*/React.createElement("polyline", {
    id: "polyline_black_2",
    className: "cls-2",
    points: "335.78 183.46 184.09 183.46 184.09 383.37"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMpLogoWhite);
export default __webpack_public_path__ + "static/media/mp_logo_white.15cf39a64c7100c6ca4dba81c8898b6e.svg";
export { ForwardRef as ReactComponent };